import { render, staticRenderFns } from "./StTeaserEventsContent.vue?vue&type=template&id=52f8580e"
import script from "./StTeaserEventsContent.vue?vue&type=script&lang=ts"
export * from "./StTeaserEventsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports